<template>
  <div>
    <div class="top">
      <Breadcrumb :options="breadcrumb" />
    </div>
    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :btns="btns"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange" >
    </Table>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";
export default {
  name: "VehicleHang",
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'inspection',
      getListUrl:'reclist',
      id:0,
      breadcrumb: [
        { name: "车辆管理", path: `/vehicle/inspect` },
        { name: "车辆年检", path: `/vehicle/inspect` },
        { name: "年检记录" },
      ],
      cols: [
        { keyName: "license", label: "车牌号" },
        { keyName: "vtype", label: "车辆类型",  className: 'pr30' },
        { keyName: "inspection_at", label: "年检时间" },
        { keyName: "cost", label: "年检费用" },
        { keyName: "institution", label: "年检机构" },
        { keyName: "updated_at", label: "更新时间" },
      ],
      // btns: [
      //   {
      //     ...this.viewBtn,
      //     title: "查看",
      //     cb: ({ id }) => {
      //       this.$router.push(
      //         `/vehicle/inspectdetail?id=${id}`
      //       );
      //     },
      //   },
      // ],
      inspection: 1,
    };
  },
  methods: {
    getid() {
      this.id = this.$route.query.id;
    },
    getList(staticfresh) {
      this.loading = true
      if (!staticfresh) {
        this.tableData = [];
      }
      let url = `${this.baseUrl}/${this.getListUrl}`;
      const params = {
        id: this.id,
        // userid: this.user.id,
        page: this.page,
        limit: this.limit,
        inspection: this.inspection,
      }
      const object = this.formInline
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key)) {
          params[key] = object[key];
        }
      }
      // console.log(url, params)
      this.post(url, params, (res) => {
        this.loading = false
        console.log(res.data)
        this.tableDataHandler(res);
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
  },
  created() {
    const { inspection } = this.$route.query
    if (inspection) {
      this.inspection = inspection
    }
  },
  mounted() {
    this.getid();
    this.getList();
  }
};
</script>
<style lang="less" scoped>
/deep/ .dialog {
  .el-form {

    .el-input,
    .el-textarea {
      width: 230px;
    }
  }

  .btns .mians {
    text-align: center;
  }
}

.top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 20px;
}
</style>